import React, { FC } from 'react'
import { RegistrationPage } from '../../../components/RegistrationPage/RegistrationPage'
import { RegistrationLayout } from '../../../layouts/RegistrationLayout/RegistrationLayout'

const RegistrationPageContainer: FC = () => {
  return (
    <RegistrationLayout withProfile withIsLoginRedirect>
      <RegistrationPage />
    </RegistrationLayout>
  )
}

RegistrationPageContainer.displayName = 'RegistrationPageContainer'

export default RegistrationPageContainer
